module.exports = __webpack_public_path__ + "static/media/left.771d3df2.svg";